import React from 'react';
import { Typography } from 'fronton-react';
import { TTableCellProps } from './table-cell-props.type';

export const Header: React.FC<TTableCellProps> = ({ title }) => (
  <div>
    <Typography color="text-minor" size="body_short" variant="s">
      {title}
    </Typography>
  </div>
);
